module.exports = __webpack_public_path__ + "img/house-book-cover.d4081b8f.png";